import React from "react";
import { Link, useParams } from "react-router-dom";

import Banner1 from "../assets/Group 1171276541.jpg";
import logo from "../assets/image/logo.png";
import hair1 from "../assets/HairReduction/img1.png";
import hair2 from "../assets/HairReduction/img2.png";
import hair3 from "../assets/HairReduction/img3.png";
import anal1 from "../assets/analysers/img1.png";
import anal2 from "../assets/analysers/img2.png";
import hydra1 from "../assets/hydrafacial/img1.png";
import hydra2 from "../assets/hydrafacial/img2.png";
import body1 from "../assets/bodysculpting/img1.png";
import body2 from "../assets/bodysculpting/img2.png";
import body3 from "../assets/bodysculpting/img3.png";
import skinlift1 from "../assets/skinlifting/img1.png";
import skinlift2 from "../assets/skinlifting/img2.png";
import hairred from "../assets/banner/hair-reduction.png";
import hydrafacial from "../assets/banner/hydrafacial.png";
import skinlifiting from "../assets/banner/Skin-Lifting.png";
import skintight from "../assets/banner/skin-tight.png";
import hairregrowth from "../assets/banner/hair-regrowth.png";
import pigmentremoval from "../assets/banner/pigment-removal.png"
import pigment1 from "../assets/pigmentremoval/img1.png";
import skintight1 from "../assets/skin-tight/img1.png";
import skintight2 from "../assets/skin-tight/img2.png";
import skintight3 from "../assets/skin-tight/img3.png";

import analbanner from '../assets/banner/analysers.png'
import bodyscupbanner from '../assets/banner/Body-sculpting.png'


import hairgrowth from '../assets/hair-regrowth/HAIR-BOOSTER.png'

const servicesData = [
  {
    id: "pigment-removal",
    bannerImg: pigmentremoval,
    sections: [
      {
        sectionId: "pigment-removal-1",
        image1: pigment1,
        logoImg: logo,
        heading: "Q-SWITCHED-ACTIVE-NDYAG",
        sectionheading: [{ left: "Face Lift", right: "Skin" }],
        content: [
          { left: "Wrinkle", right: "Scar Remover" },
          { left: "Skin Tightening", right: "Skin Tightening" },
        ],
      },
    ],
  },

  {
    id: "hair-reduction",
    bannerImg: hairred,
    sections: [
      {
        image1: hair1,
        logoImg: logo,
        heading: "Diode-Laser-Hair-Removal ",
        sectionheading: [{ left: "Face Lift", right: "Skin" }],
        content: [
          { left: "Wrinkle", right: "Scar Remover" },
          { left: "Skin Tightening", right: "Skin Tightening" },
        ],
      },
      {
        image1: hair2,
        logoImg: logo,
        heading: "DIODE-HAIR-REMOVAL",
        sectionheading: [{ left: "Face Lift", right: "Skin" }],
        content: [
          { left: "Wrinkle", right: "Scar Remover" },
          { left: "Skin Tightening", right: "Skin Tightening" },
        ],
      },
      {
        image1: hair3,
        logoImg: logo,
        heading: "Diode-Italo",
        sectionheading: [{ left: "Face Lift", right: "Skin" }],
        content: [
          { left: "Wrinkle", right: "Scar Remover" },
          { left: "Skin Tightening", right: "Skin Tightening" },
        ],
      },
    ],
  },
  {
    id: "skin-tight",
    bannerImg: skintight,
    sections: [
      {
        image1: skintight1,
        logoImg: logo,
        heading: "FMNRF-crystilite",
        sectionheading: [{ left: "Face Lift", right: "Skin" }],
        content: [
          { left: "Wrinkle", right: "Scar Remover" },
          { left: "Skin Tightening", right: "Skin Tightening" },
        ],
      },
      {
        image1: skintight2,
        logoImg: logo,
        heading: "mnrf-verticle",
        sectionheading: [{ left: "Face Lift", right: "Skin" }],
        content: [
          { left: "Wrinkle", right: "Scar Remover" },
          { left: "Skin Tightening", right: "Skin Tightening" },
        ],
      },
      {
        image1: skintight3,
        logoImg: logo,
        heading: "MNRF-PORTABLE",
        sectionheading: [{ left: "Face Lift", right: "Skin" }],
        content: [
          { left: "Wrinkle", right: "Scar Remover" },
          { left: "Skin Tightening", right: "Skin Tightening" },
        ],
      },
    ],
  },
  {
    id: "analysers",
    bannerImg: analbanner,
    sections: [
      {
        image1: anal1,
        logoImg: logo,
        heading: "OFunction-Analyser ",
        sectionheading: [{ left: "Face Lift", right: "Skin" }],
        content: [
          { left: "Wrinkle", right: "Scar Remover" },
          { left: "Skin Tightening", right: "Skin Tightening" },
        ],
      },
      {
        image1: anal2,
        logoImg: logo,
        heading: "SKIN-AND-HAIR-ANALYSERS",
        sectionheading: [{ left: "Face Lift", right: "Skin" }],
        content: [
          { left: "Wrinkle", right: "Scar Remover" },
          { left: "Skin Tightening", right: "Skin Tightening" },
        ],
      },
    ],
  },
  {
    id: "skin-lifting",
    bannerImg: skinlifiting,
    sections: [
      {
        image1: skinlift1,
        logoImg: logo,
        heading: "HIFU-ULTRALIFT",
        sectionheading: [{ left: "Face Lift", right: "Skin" }],
        content: [
          { left: "Wrinkle", right: "Scar Remover" },
          { left: "Skin Tightening", right: "Skin Tightening" },
        ],
      },
      {
        image1: skinlift2,
        logoImg: logo,
        heading: "Vertical-Face-EMR",
        sectionheading: [{ left: "Face Lift", right: "Skin" }],
        content: [
          { left: "Wrinkle", right: "Scar Remover" },
          { left: "Skin Tightening", right: "Skin Tightening" },
        ],
      },
    ],
  },
  {
    id: "hydrafacial",
    bannerImg: hydrafacial,
    sections: [
      {
        image1: hydra1,
        logoImg: logo,
        heading: "Alice-super-bubble-ultrasonic-hydro-massage",
        sectionheading: [{ left: "Face Lift", right: "Skin" }],
        content: [
          { left: "Wrinkle", right: "Scar Remover" },
          { left: "Skin Tightening", right: "Skin Tightening" },
        ],
      },
      {
        image1: hydra2,
        logoImg: logo,
        heading: "oxygen-jet-peel-pdt-led-light-therapy-facial-machine",
        sectionheading: [{ left: "Face Lift", right: "Skin" }],
        content: [
          { left: "Wrinkle", right: "Scar Remover" },
          { left: "Skin Tightening", right: "Skin Tightening" },
        ],
      },
    ],
  },
  {
    id: "body-sculpting",
    bannerImg: bodyscupbanner,
    sections: [
      {
        image1: body1,
        logoImg: logo,
        heading: "2 in 1 SCULPTURE AND CRYOLIPOLYSIS MACHINE ",
        sectionheading: [{ left: "Face Lift", right: "Skin" }],
        content: [
          { left: "Wrinkle", right: "Scar Remover" },
          { left: "Skin Tightening", right: "Skin Tightening" },
        ],
      },
      {
        image1: body2,
        logoImg: logo,
        heading: "Rotary-Negative-Pressure-RF",
        sectionheading: [{ left: "Face Lift", right: "Skin" }],
        content: [
          { left: "Wrinkle", right: "Scar Remover" },
          { left: "Skin Tightening", right: "Skin Tightening" },
        ],
      },
      {
        image1: body3,
        logoImg: logo,
        heading: "CAVIZERO",
        sectionheading: [{ left: "Face Lift", right: "Skin" }],
        content: [
          { left: "Wrinkle", right: "Scar Remover" },
          { left: "Skin Tightening", right: "Skin Tightening" },
        ],
      },
    ],
  },
  {
    id: "hair-regrowth",
    bannerImg: hairregrowth,
    sections: [
      {
        image1: hairgrowth,
        logoImg: logo,
        heading: "Hair-Booster ",
        sectionheading: [{ left: "Face Lift", right: "Skin" }],
        content: [
          { left: "Wrinkle", right: "Scar Remover" },
          { left: "Skin Tightening", right: "Skin Tightening" },
        ],
      },
      
    ],
  },

  // Add more services as needed
];

function ServicePage() {
  const { serviceId } = useParams();

  // Find the service data based on the URL param (serviceId)
  const service = servicesData.find((s) => s.id === serviceId);

  // If no matching service is found, return a 404-like message
  if (!service) {
    return <h1>Service Not Found</h1>;
  }

  return (
    <div className="main relative top-[50px] mb-10 h-full" id={service.id}>
      <div className="banner w-full">
        <img
          src={service.bannerImg}
          className="w-full object-cover " // Adjust the banner height for mobile
          alt="banner"
        />
      </div>
      <div className="flex justify-center">
        <div className="container">
          <div className="grid grid-cols-1 gap-5">
            {service.sections.map((section, index) => (
              <div className="mt-5" key={index}>
                <div className="border border-gray-300 rounded-xl p-5 flex items-center justify-center flex-col md:flex-row gap-5 md:gap-16 shadow-lg hover:shadow-xl transition-shadow duration-300">
                  {/* Product Image */}
                  <div className="flex justify-center">
                    <img
                      src={section.image1}
                      className="w-48 md:w-56 object-cover rounded-lg transition-transform transform hover:scale-105"
                      alt="section image"
                    />
                  </div>

                  {/* Product Details */}
                  <div className="flex flex-col justify-between w-full">
                    {/* Logo */}
                    <div className="mb-4 text-center md:text-left">
                      <img src={section.logoImg} alt="logo" className="w-80 " />
                    </div>

                    {/* Product Heading */}
                    <h1 className="font-bold text-lg md:text-2xl text-colorPrimary uppercase tracking-wide">
                      {section.heading}
                    </h1>

                    {/* Key Features */}
                    <div className="mt-4">
                      <h2 className="font-bold text-lg text-gray-800 mb-2">
                        Key Features
                      </h2>
                      <div className="grid grid-cols-2 gap-2">
                        {section.sectionheading.map((item, idx) => (
                          <React.Fragment key={idx}>
                            <div className="px-3 py-2 text-sm bg-colorPrimary text-center rounded-full text-white shadow hover:bg-opacity-80 transition duration-300">
                              <h1>{item.left}</h1>
                            </div>
                            <div className="px-3 py-2 bg-colorPrimary rounded-full text-center text-white shadow hover:bg-opacity-80 transition duration-300">
                              <h1>{item.right}</h1>
                            </div>
                          </React.Fragment>
                        ))}
                      </div>
                    </div>

                    {/* Additional Content */}
                    <div className="mt-6">
                      <h2 className="font-bold text-lg text-gray-800 mb-2">
                        Additional Information
                      </h2>
                      <div className="grid grid-cols-2 gap-2">
                        {section.content.map((item, idx) => (
                          <React.Fragment key={idx}>
                            <div className="bg-gray-100 p-2 rounded-lg shadow hover:shadow-md transition-shadow duration-300">
                              <h1 className="font-semibold text-gray-700">
                                {item.left}
                              </h1>
                            </div>
                            <div className="bg-gray-100 p-2 rounded-lg shadow hover:shadow-md transition-shadow duration-300">
                              <h1 className="text-gray-700 font-semibold">
                                {item.right}
                              </h1>
                            </div>
                          </React.Fragment>
                        ))}
                      </div>
                    </div>

                    {/* Rating Section */}
                    <div className="flex items-center mt-4">
                      <span className="text-yellow-500 font-bold">
                        ⭐⭐⭐⭐⭐
                      </span>
                      <span className="text-gray-500 ml-2">(200 Reviews)</span>
                    </div>

                    {/* Price and Add to Cart */}
                    <div className="mt-5 text-center md:text-left">
                      {/* <h2 className="text-2xl font-bold text-gray-800">
        ₹{section.price}{' '}
        <span className="line-through text-gray-500 text-sm">M.R.P: ₹{section.mrp}</span>
      </h2> */}
                      <p className="text-green-600 font-semibold">
                        {section.discount}
                      </p>
                      <button className="bg-yellow-400 hover:bg-yellow-500 text-black font-bold py-2 px-4 rounded mt-3 transition-transform transform hover:scale-105">
                        <Link
                          // to={`/service/${service.id}/section/${section.sectionId}`}
                          className="block"
                        >
                          More Details
                        </Link>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ServicePage;
